import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "./UpdateNotification.scss";

const UpdateNotification = () => {
    const [seconds, setSeconds] = useState(5);

    useEffect(() => {
        const timer = setInterval(() => {
            setSeconds((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    window.location.reload(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const handleRefreshNow = () => {
        window.location.reload(true);
    };

    const circumference = 2 * Math.PI * 35;
    const progress = ((5 - seconds) / 5) * circumference;

    return createPortal(
        <div className="update-overlay">
            <div className="update-card">
                <div className="update-icon">
                    <svg className="countdown-ring" width="90" height="90">
                        <circle
                            className="countdown-ring-circle-bg"
                            cx="45"
                            cy="45"
                            r="35"
                            fill="none"
                            stroke="#414141"
                            strokeWidth="6"
                        />
                        <circle
                            className="countdown-ring-circle"
                            cx="45"
                            cy="45"
                            r="35"
                            fill="none"
                            stroke="#35d269"
                            strokeWidth="6"
                            strokeDasharray={circumference}
                            strokeDashoffset={circumference - progress}
                            strokeLinecap="round"
                            transform="rotate(-90 45 45)"
                        />
                        <text
                            x="45"
                            y="45"
                            textAnchor="middle"
                            dy="7"
                            fontSize="28"
                            fontWeight="bold"
                            fill="#35d269"
                        >
                            {seconds}
                        </text>
                    </svg>
                </div>

                <h2 className="update-title">New Update Available!</h2>
                <p className="update-message">
                    Refreshing in <strong>{seconds}</strong> {seconds === 1 ? "second" : "seconds"}
                </p>

                <button className="update-button" onClick={handleRefreshNow}>
                    Refresh Now
                </button>

                <p className="update-note">All caches will be cleared automatically</p>
            </div>
        </div>,
        document.body
    );
};

export default UpdateNotification;
